import { useTranslation } from 'react-i18next';

import PageLayout from '~layouts/page/pageLayout';

import WebhookDetailsContainer from '../containers/webhookDetailsContainer';

interface Props {
	type: 'rental';
}

const WebhookDetailsPage = ({ type: _type }: Props) => {
	const { t } = useTranslation();

	return (
		<PageLayout
			pageTitle={t('webhook.labels.single', { ns: 'entities' })}
			headerInfo={{
				title: t('webhook.labels.single', { ns: 'entities' }),
			}}
		>
			<WebhookDetailsContainer />
		</PageLayout>
	);
};

export default WebhookDetailsPage;
